import React from "react";
import Icon from "./Icon";

export default class Settings extends React.PureComponent {
    render() {
        return (
            <Icon className={'settings'} img={require('../../../assets/images/icons/settings-white.png')}/>
        )
    }
}
